export class Userlevel
{
    constructor(
        public userLevelId? :number,
        public userLevelName = '',
        public description = ''

        ) 
        { }

}
